module.exports = __webpack_public_path__ + "static/media/ic-business-img-placeholder.0ca7e72f.svg";